import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    content: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(4),
      padding: theme.spacing(2.5, 3),
    },
    footer: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      padding: theme.spacing(2, 3),
      borderTop: theme.shape.borderGray70,
    },
  }),
  { name: 'ImageOverlayForm' }
);
